// This file (index.ts) activates all listeners.
// For the detailed guide please see: https://redux-toolkit.js.org/api/createListenerMiddleware

import "./magento.listeners";
import "./loyalty.listeners";
